import styled from 'styled-components'

export const PatientConsumptionContainer = styled.div`
  width: 100%;
`

export const CheckBoxOptions = styled.div`
  margin: 12px 0 10px;

  display: flex;
  flex-wrap: wrap;
  gap: 8px 23px;
`